export const visit = (vm, at) => {
vm(require("foundations-components/lang/lt.lyaml"));
at({ "lt": { "placeholder": "vietos rezervavimo \u017Eenklas" } });
};